<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Gsm Onay (Yeni Müşteriler)</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <li class="breadcrumb-item active">Gsm Onay (Yeni Müşteriler)</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Gsm Onay (Yeni Müşteriler) Loglar

                <button
                  class="btn btn-outline-secondary btn-sm float-right"
                  @click="openModal"
                >
                  <i class="fas fa-cogs"> </i> Ayarlar
                </button>
              </div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        placeholder="Müşteri ID"
                        class="form-control form-control-sm"
                        v-model="search.code"
                      />
                    </div>

                    <div class="col">
                      <button class="btn btn-info btn-sm" @click="pagination">
                        <i class="fas fa-search"></i> Filtrele
                      </button>
                      <button class="btn btn-danger btn-sm" @click="reset">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <hr />
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Müşteri ID</th>
                        <th>Tarih</th>
                        <th>Gsm Numarası</th>
                        <th>Onay Kodu</th>
                        <th>Deneme Sayısı</th>
                        <th>Talep</th>
                        <th>Durum</th>
                        <th>Mesaj</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in datas" :key="index">
                        <td>{{ ++index + (page - 1) * count }}</td>
                        <td>{{ data.customer }}</td>
                        <td>{{ data.date | DateFormat }}</td>
                        <td>{{ data.phone }}</td>
                        <td>{{ data.code }}</td>
                        <td>{{ data.deneme }}</td>
                        <td>
                          {{ data.isType ? "Casino Bonus" : "Spor Bonus" }}
                        </td>
                        <td>
                          {{ data.isRed ? "Üye Reddetti" : "" }}
                          {{ !data.isSuccess ? "Gsm Doğrulanmadı" : "" }}
                          {{
                            !data.isValid && data.isSuccess && !data.isError
                              ? "Bonus Ataması Bekliyor"
                              : ""
                          }}
                          {{ data.isError ? "Bonus Verilmedi" : "" }}
                          {{ data.isValid ? "Bonus Verildi" : "" }}
                        </td>
                        <td>{{ data.message }}</td>
                      </tr>
                      <tr>
                        <td
                          v-if="datas.length == 0"
                          colspan="9"
                          class="text-center"
                        >
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination
                  v-model="page"
                  :records="rows"
                  :per-page="count"
                  @paginate="pagination"
                />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->

    <!--Modal-->
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tekrar Sayısı Ayarları</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-10">
                <input
                  class="form-control"
                  placeholder="Tekrar Sayısı"
                  type="number"
                  v-model="again"
                />
              </div>
              <div class="col-2">
                <button class="btn btn-primary" @click="save">Kaydet</button>
              </div>
            </div>
            <hr />
            <small class="text-danger"
              >* Tekrar sayısı ile ilgili son 10 değişiklik bilgisi</small
            >
            <ul class="list-group">
              <li class="list-group-item">
                <div class="row">
                  <div class="col"><b>Personel</b></div>
                  <div class="col"><b>Tarih</b></div>
                  <div class="col-2 text-center"><b>Tekrar</b></div>
                </div>
              </li>
              <li class="list-group-item" v-for="data in agains" :key="data.ID">
                <div class="row">
                  <div class="col">{{ data.user }}</div>
                  <div class="col">{{ data.date | DateFormat }}</div>
                  <div class="col-2 text-center">{{ data.tekrar }}</div>
                </div>
              </li>
              <li class="list-group-item" v-if="agains.length == 0">
                <div class="row">
                  <div class="col text-center">Kayıt Bulunamadı</div>
                </div>
              </li>
            </ul>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      count: 10,
      rows: 0,
      overlay: false,
      datas: [],
      again: 0,
      agains: [],
      search: {
        code: "",
      },
    };
  },
  methods: {
    pagination(value) {
      this.getDatas();
      this.getDatas(true);
    },
    reset() {
      this.search = {
        code: "",
      };
      this.getDatas();
      this.getDatas(true);
    },
    getDatas(type = false) {
      this.overlay = true;
      this.$http
        .post("GsmNewCustomer/ListRequest", {
          code: this.search.code,
          rowNumber: type,
          page: this.page - 1,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else this.datas = response.data;

          this.overlay = false;
        });
    },
    openModal() {
      this.getLogs();
      this.getAgain();
      $("#modal").modal();
    },
    getLogs() {
      this.$http.get("GsmNewCustomer/ListAgainLog").then((response) => {
        this.agains = response.data;
      });
    },
    getAgain() {
      this.$http.get("GsmNewCustomer/GetAgain").then((response) => {
        this.again = response.data.tekrar;
      });
    },
    save() {
      this.$http
        .get("GsmNewCustomer/AgainAdd/" + this.again)
        .then((response) => {
          toastr.success("Kayıt başarılı.");
        });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getDatas();
    this.getDatas(true);
  },
  watch: {
    "$store.getters.getSite"() {
      this.getDatas();
      this.getDatas(true);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Report/GsmNewCustomerReport.vue